import { Policy } from "../model/policy/Policy";

export class PolicyPostCommand{
    PolicyView:Policy;

    constructor(policyView:Policy){
        this.PolicyView = policyView;
    }
}